import TranslationModel from '../../../../../Spirit/Admin/Interfaces/Models/TranslationModel';
import AudiofilesGetListResponse from '../../../../../Spirit/Admin/Interfaces/Models/MusicService/AudiofilesGetListResponse';
import AudioFileAlbumCategoryResponse from '../../../../../Spirit/Admin/Interfaces/Models/MusicService/AudioFileAlbumCategoryResponse';

export default class AlbumGetDetailReponse  {
	Id: number = 0;
	CoverUrl?: string = '';
	BackgroundUrl?: string = '';
	IsPaid: boolean = false;
	IsSleep: boolean = false;
	UseOnMainDisplay: boolean = false;
	AnimationId?: string = '';
	AlbumTranslations: Array<TranslationModel> = null;
	Audiofiles: Array<AudiofilesGetListResponse> = null;
	Categories: Array<AudioFileAlbumCategoryResponse> = null;
	constructor(obj?: Partial<AlbumGetDetailReponse>) {
		if (obj) {
			Object.assign(this, obj);
		}
	}
}
